import Button from '@mui/material/Button'
import React from 'react'
import { getButtonTestId } from './getButtonTestId'

/** @notExported  */
interface ToolbarButtonProps {
  /** Action to be performed when the button is clicked. */
  clickAction: () => void
  /** Button content. */
  children: React.ReactNode
  /** Test id of the button. */
  testId?: string
}

/**
 * Toolbar button.
 *
 * @returns Toolbar button component.
 * @notExported
 * @category Buttons
 */
const ToolbarButton: React.FC<ToolbarButtonProps> = ({ clickAction, children, testId }) => {
  const resolvedTestId = getButtonTestId({ fallback: 'button-toolbar', label: children, testId })

  return (
    <Button
      id="search"
      data-testid={resolvedTestId}
      type="button"
      onClick={() => clickAction()}
      sx={{
        fontWeight: 'bold',
        '&:hover': {
          backgroundColor: theme => theme.palette.secondary.light,
        },
        width: '100%',
        height: '100%',
      }}
    >
      {children}
    </Button>
  )
}

export default ToolbarButton
